export enum TABS {
  DETAILS = 'details',
  UPLOADED_CONTENT = 'uploadedContent',
  COVER_PHOTOS = 'coverPhotos',
  MUSIC = 'music',
  TRIBUTE_VIDEOS = 'tributeVideos',
  TEXT = 'text',
  TEXT_OVERLAY = 'textOverlay',
  CEREMONY = 'ceremony',
  LIVE_STREAM = 'liveStream'
}
